import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ChangeDeal from '../../ChangeDeal';

class ChangeDealModal extends Component {
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {
    className: ''
  };
  render() {
    const { className } = this.props;
    const classList = classNames('change-client-modal', className);
    return <ChangeDeal className={classList} />;
  }
}

export default ChangeDealModal;
